//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import KIcon from './KIcon';

export default {
  name: 'KLabeledIcon',
  components: {
    KIcon,
  },
  props: {
    // An icon that will be prepended to the label. Uses the same icon names as the `KIcon` component
    icon: {
      type: String,
      required: false,
    },
    // An icon that will be appended to the label. Uses the same icon names as the `KIcon` component
    iconAfter: {
      type: String,
      required: false,
    },
    // If provided, determines the color of the label and any icons that are provided
    color: {
      type: String,
      required: false,
    },
    // If provided, will place this text in the default slot
    label: {
      type: String,
      required: false,
    },
    // If provided, will limit label width to this value
    maxWidth: {
      type: String,
      required: false,
      default: '100%',
    },
  },
  computed: {
    labelEmpty() {
      if (this.label) {
        return false;
      }

      if (!('default' in this.$slots) || !this.$slots.default.length) {
        return true;
      }

      const defaultSlot = this.$slots.default[0];
      return !(
        defaultSlot.text ||
        defaultSlot.tag ||
        (defaultSlot.children && defaultSlot.children.length)
      );
    },
    labelStyle() {
      let styles = {};
      let margins = 0;
      let leftLtr = this.isRtl ? 'marginRight' : 'marginLeft';
      let rightLtr = this.isRtl ? 'marginLeft' : 'marginRight';
      // Margin for icons - use em to match parent font size
      if (this.iconAfter || this.$slots['iconAfter']) {
        styles[rightLtr] = '1.975em'; // scale with parent font size
        margins += 1.975;
      }

      if (this.icon || this.$slots['icon']) {
        styles[leftLtr] = '1.975em'; // scale with parent font size
        margins += 1.975;
      }

      const maxWidth = margins > 0 ? `calc(${this.maxWidth} - ${margins}em)` : this.maxWidth;
      return { ...styles, maxWidth };
    },
  },
};

